import {graphql, useStaticQuery} from "gatsby";

export const useHeroPhoto = () => {
  const images = useStaticQuery(graphql`
      query {
          about: file(relativePath: { eq: "images/heros/about.png" }) {
              childImageSharp {
                  fluid(maxWidth: 2600, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
          ads: file(relativePath: { eq: "images/heros/ads.png" }) {
              childImageSharp {
                  fluid(maxWidth: 2600, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
          apps: file(relativePath: { eq: "images/heros/apps.png" }) {
              childImageSharp {
                  fluid(maxWidth: 2600, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
          blog: file(relativePath: { eq: "images/heros/blog.png" }) {
              childImageSharp {
                  fluid(maxWidth: 2600, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
          branding: file(relativePath: { eq: "images/heros/branding.png" }) {
              childImageSharp {
                  fluid(maxWidth: 2600, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
          career: file(relativePath: { eq: "images/heros/career.png" }) {
              childImageSharp {
                  fluid(maxWidth: 2600, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
          contact: file(relativePath: { eq: "images/heros/contact.png" }) {
              childImageSharp {
                  fluid(maxWidth: 2600, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
          copy: file(relativePath: { eq: "images/heros/copy.png" }) {
              childImageSharp {
                  fluid(maxWidth: 2600, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }

          ecommerce: file(relativePath: { eq: "images/heros/ecommerce.png" }) {
              childImageSharp {
                  fluid(maxWidth: 2600, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
          kariera: file(relativePath: { eq: "images/heros/kariera.png" }) {
              childImageSharp {
                  fluid(maxWidth: 2600, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
          ilustracje: file(relativePath: { eq: "images/heros/ilustracje.png" }) {
              childImageSharp {
                  fluid(maxWidth: 2600, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
          media: file(relativePath: { eq: "images/heros/media.png" }) {
              childImageSharp {
                  fluid(maxWidth: 2600, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
          models: file(relativePath: { eq: "images/heros/3d.png" }) {
              childImageSharp {
                  fluid(maxWidth: 2600, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
          oferta: file(relativePath: { eq: "images/heros/oferta.png" }) {
              childImageSharp {
                  fluid(maxWidth: 2600, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
          offer_webdesigng: file(
              relativePath: { eq: "images/heros/webdesign.png" }
          ) {
              childImageSharp {
                  fluid(maxWidth: 2600, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
          realisation: file(relativePath: { eq: "images/heros/realisation.png" }) {
              childImageSharp {
                  fluid(maxWidth: 2600, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
          r_design: file(relativePath: { eq: "images/heros/r_design.png" }) {
              childImageSharp {
                  fluid(maxWidth: 2600, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
          r_marketing: file(relativePath: { eq: "images/heros/r_marketing.png" }) {
              childImageSharp {
                  fluid(maxWidth: 2600, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
          r_media: file(relativePath: { eq: "images/heros/r_media.png" }) {
              childImageSharp {
                  fluid(maxWidth: 2600, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
          r_webpages: file(relativePath: { eq: "images/heros/r_webpages.png" }) {
              childImageSharp {
                  fluid(maxWidth: 2600, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
          seo: file(relativePath: { eq: "images/heros/seo.png" }) {
              childImageSharp {
                  fluid(maxWidth: 2600, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
          social: file(relativePath: { eq: "images/heros/social.png" }) {
              childImageSharp {
                  fluid(maxWidth: 2600, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
          solutions: file(relativePath: { eq: "images/heros/solutions.png" }) {
              childImageSharp {
                  fluid(maxWidth: 2600, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
          webpages: file(relativePath: { eq: "images/heros/webpages.png" }) {
              childImageSharp {
                  fluid(maxWidth: 2600, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
          ppwb: file(relativePath: { eq: "images/heros/ppwb.png" }) {
              childImageSharp {
                  fluid(maxWidth: 3600, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
           parp: file(relativePath: { eq: "images/heros/parp.png" }) {
              childImageSharp {
                  fluid(maxWidth: 862, quality: 100) {
                      ...GatsbyImageSharpFluid_withWebp
                  }
              }
          }
      }
  `);
  return images;
};
